import { createSelector } from 'reselect';

import { RootState } from '~/store';
import { ConfigurationInterface } from '@e3labs/isa-data-dictionary';

const selectConfiguration = (state: RootState) => state.configuration;

export const selectorConfiguration = createSelector(
  selectConfiguration,
  (substate: ConfigurationInterface) => substate
);

export const selectEnableAIRoutingSuggestion = (state: RootState): boolean =>
  state?.configuration?.enableAIRoutingSuggestion === true;
